import React from "react";

function ABOUTME() {
  return (
    <div className="bg-light my-5">
      <div className="container text-center py-5">
        <h1 className="text-center font-weight-light">
          <span className="text-info">About</span> me
        </h1>
        <div className="lead">
          I can develop the front and the back of an app
        </div>
        <div className="row">
          <div className="col-12 col-md-6 px-5 pt-5">
            <h5>What I can do?</h5>
            <p className="text-justify">
              As a beginner-friendly full stack developer, I focus on creating
              user-friendly web experiences. From designing appealing front-end
              interfaces to managing server-side development, I ensure smooth
              application functionality. With a grasp of the development process
              and a passion for problem-solving, I follow agile methodologies
              and prioritize effective communication. Let's collaborate to bring
              your web project to life with beginner-friendly solutions.
            </p>
          </div>
          <div className="col-12 col-md-6 px-5 pt-5">
            <h5>What am I doing currently?</h5>
            <p className="text-justify">
              I'm currently pursuing Masters in Computer Application, actively
              expanding my skills as a full stack developer. Alongside my
              studies, I am working on professional projects, learning new
              technologies like React, and exploring cloud platforms such as
              AWS. Additionally, I am building personal projects to refine my
              skills and actively engaging with the developer community through
              forums and meetups. My dedication to continuous learning fuels my
              passion for delivering high-quality solutions in full stack
              development.
            </p>
          </div>
          <div className="col-12 col-md-6 px-5 pt-5">
            <h5>What do I believe in?</h5>
            <p className="text-justify">
              I believe in the power of curiosity and continuous learning. I am
              passionate about exploring new technologies and embracing
              challenges as opportunities for growth. Collaboration and open
              communication are at the heart of my approach, understanding that
              teamwork and knowledge-sharing lead to remarkable results. I value
              simplicity and user-centric design, aiming to create intuitive
              solutions that make a positive impact. With unwavering dedication
              and a thirst for knowledge, I am committed to delivering quality
              and surpassing expectations. Let's embark on a journey of learning
              and creation together, where we can unlock the full potential of
              your ideas
            </p>
          </div>
          <div className="col-12 col-md-6 px-5 pt-5">
            <h5>How I can help you?</h5>
            <p className="text-justify">
              Prepare to witness the transformation of your ideas into digital
              masterpieces! I am your trusted ally, armed with the skills of a
              full stack developer, ready to craft captivating websites and
              dynamic web applications that will leave your audience in awe.
              From front-end wizardry to back-end sorcery, I possess the powers
              to create seamless user experiences and unleash the full potential
              of your vision. Whether you seek to conquer technical challenges
              or embark on a creative adventure, I am here to bring your dreams
              to life. Let's collaborate and weave digital wonders together!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ABOUTME;
